import { Button, Flex } from "@chakra-ui/react";
import useAprovarSolicitacao from "core/features/SolicitacaoCadastro/hooks/useAprovarSolicitacao";
import useRejeitarSolicitacao from "core/features/SolicitacaoCadastro/hooks/useRejeitarSolicitacao";
import { StatusSolicitacaoCadastroEnum } from "core/features/SolicitacaoCadastro/typings";
import { showConfirm, showErrorAxios } from "infra/helpers/alerta";
import { useCallback } from "react";
import PrimaryButton from "ui/components/Button/PrimaryButton";

export interface SolicitacaoAcoesProps {
  id: string;
  status: StatusSolicitacaoCadastroEnum;
  refetch?: () => any;
}

function SolicitacaoAcoes(props: SolicitacaoAcoesProps) {
  const { mutate: aprovar, isLoading: isAprovando } = useAprovarSolicitacao();
  const { mutate: rejeitar, isLoading: isRejeitando } =
    useRejeitarSolicitacao();

  const aprovarSolicitacao = useCallback(async () => {
    const { isConfirmed } = await showConfirm(
      "Deseja realmente aprovar o cadastro?"
    );

    if (isConfirmed) {
      aprovar(props.id, {
        onSuccess: props.refetch,
        onError: (e) => showErrorAxios(e),
      });
    }
  }, [aprovar, props.id, props.refetch]);

  const rejeitarSolicitacao = useCallback(async () => {
    const { isConfirmed, value } = await showConfirm(
      "Deseja realmente rejeitar o cadastro?",
      {
        input: "textarea",
        inputPlaceholder: "Motivo da rejeição",
      }
    );

    if (isConfirmed) {
      rejeitar(
        { id: props.id, statusMotivo: value },
        {
          onSuccess: props.refetch,
          onError: (e) => showErrorAxios(e),
        }
      );
    }
  }, [props.id, props.refetch, rejeitar]);

  if (props.status === StatusSolicitacaoCadastroEnum.Aprovado) {
    return null;
  }

  return (
    <Flex
      mx="auto"
      mb="40px"
      marginTop="-70px"
      gridGap="17px"
      justifyContent="flex-end"
    >
      {props.status !== StatusSolicitacaoCadastroEnum.Rejeitado && (
        <Button
          isLoading={isRejeitando}
          disabled={isAprovando}
          w="87px"
          h="35px"
          color="#FFFFFF"
          colorScheme="red"
          fontWeight="normal"
          onClick={rejeitarSolicitacao}
        >
          Rejeitar
        </Button>
      )}

      <PrimaryButton
        isLoading={isAprovando}
        disabled={isRejeitando}
        w="87px"
        h="35px"
        onClick={aprovarSolicitacao}
      >
        Aprovar
      </PrimaryButton>
    </Flex>
  );
}

export default SolicitacaoAcoes;
